import css from 'styled-jsx/css';

export const styles = css`
  .BigProductCardShareButton {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .BigProductCardShareButton__icon {
    font-size: 18px;
    padding: 10px;
    cursor: pointer;
    color: var(--colors-brandLightGrey8);
  }

  .BigProductCardShareButton__icon_active,
  .BigProductCardShareButton__icon:hover {
    color: var(--colors-text);
  }
`;
